import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import type { FrameworkRoutePreviewRequest, FrameworkRouteResponse } from '$/requests/FrameworkRoute.ts';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

const useFrameworkRoutePreview = () =>
  useMutation({
    mutationFn: (body: FrameworkRoutePreviewRequest) => submitFrameworkRoutePreview(body),
  });

export default useFrameworkRoutePreview;

async function submitFrameworkRoutePreview(
  body: FrameworkRoutePreviewRequest,
): Promise<FrameworkRouteResponse> {
  const { data, error } = await supabaseClient.functions.invoke('framework-route-preview', { body });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();
    throw new Error(errorResponse.errors?.join(', ') ?? 'Diagnostic preview failed');
  }

  return data.data as FrameworkRouteResponse;
}
